<dx-form
  #websiteFormRef
  class="website-form__form"
  [formData]="formData"
  [validationGroup]="validationGroup"
  labelMode="floating"
  [scrollingEnabled]="true"
  (onFieldDataChanged)="websiteFormRef?.instance?.validate()"
>
  <dxi-item
    [isRequired]="true"
    [dataField]="WebsiteKeys.websiteType"
    [editorType]="'dxSelectBox'"
    [label]="{ text: 'Type' }"
    [editorOptions]="{
      items: websitesTypesLookup,
      displayExpr: LookupKeys.description,
      valueExpr: BaseModelKeys.dbId,
      showClearButton: false,
    }"
  >
    <dxi-validation-rule type="required" [message]="'Type is Required'"></dxi-validation-rule>
  </dxi-item>

  <dxi-item [isRequired]="true" [dataField]="WebsiteKeys.url" editorType="dxTextBox" [label]="{ text: 'URL' }">
    <dxi-validation-rule
      type="custom"
      [message]="Messages.INVALID_URL_FORMAT_TEXT"
      [validationCallback]="validateUrlWithoutProtocol"
    ></dxi-validation-rule>
    <dxi-validation-rule type="required" [message]="Messages.REQUIRED_URL_TEXT"></dxi-validation-rule>
  </dxi-item>
</dx-form>
